/* global window, jQuery */
// NOTE - jQuery/$ are coming from webpack

// Added for Split.io... and promises are nice to have all the time
require('core-js/fn/promise');
require('core-js/fn/object/values');
require('bootstrap/scss/bootstrap.scss');
require('fancybox/dist/scss/jquery.fancybox.scss');
require('public/css/main.scss');
require('owl.carousel/dist/assets/owl.carousel.css');

const $onReady = require('public/js/lib/on-ready');
// Setup our faux ajax handler so plugin can take over if necessary
window.$ajax = window.$ajax || jQuery.ajax;

// Assign jquery to our internal rp$ variable
// In the plugin case, be more careful about not clobbering existing $'s
if (window.__IS_WEBSTORE_PLUGIN) {
	window.rp$ = jQuery.noConflict();
} else {
	window.rp$ = jQuery;
}

window.rp_app = require('public/js/app');

if (!window.__IS_WEBSTORE_PLUGIN) {
	window.addEventListener('error', window.rp_app.logger.handleErrorEvent, true);
}

require('fancybox')(rp$);
require('owl.carousel');
// require('select2/dist/js/select2.min.js');

const NumberFormat = require('@revolutionparts/number-format')();

window.rp_app.activeMakes = [];
window.rp_app.priceFormat = function(price) {
	return NumberFormat.currency(price);
};
window.rp_app.request = require('public/js/lib/request');

// JQuery Plugins
require('public/js/components/vehicle-picker');
require('public/js/components/cart');
const searchBox = require('public/js/components/search-box');

require('public/js/elements/email-addresses');
const contactable = require('public/js/elements/contactable');
require('public/js/elements/overlay-spinner');
const flyouts = require('public/js/elements/flyouts');

//Wishlist Actions
require('public/js/components/wishlist');

require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/popover');
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/dropdown');

const onReady = function () {
	/* Pull in active makes
	.*-----------------------------------------*/
	$ajax({
		dataType: 'json',
		url: '/ajax/vehicle-picker/makes/all',
		success : function(response/*, type, xhr*/) {
			window.rp_app.activeMakes = response;
		},
	});
	flyouts.attachEvents();

	/* Bootstrap
	.*-----------------------------------------*/
	rp$('.carousel').carousel();

	/* Call vehiclepicker on select elements
	.*-----------------------------------------*/
	rp$('.vehiclepicker_classic, .vehiclepicker').vehiclepicker({});
	rp$('.vehiclepicker_link, .vehiclepicker-link').vehiclepicker_link();

	/* Add to Cart
	.*-----------------------------------------*/
	rp$('.add-to-cart.enabled').add_to_cart();

	/* Fix email address
	.*-----------------------------------------*/
	rp$('.email-address').emailAddress();
	contactable.attach();

	/* Trigger Lightbox
	.*-----------------------------------------*/
	rp$('.fancybox-link').fancybox({
		parent: '#rp_webstore',
	});


	/* Add Popover
	.*-----------------------------------------*/
	rp$('.popover-tooltip').popover({
		trigger: 'hover',
		placement: 'bottom'
	});

	searchBox.setupSearchBox();
};

module.exports = () => {
	$onReady({fn: onReady, rp$, window, label: 'main'});
};
